<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <!-- Header -->
    <div
        class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 pr-1">

        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="backToManageBrief()" type="button" class="btn-fab-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                @if (creatorInquiry()) {
                <div class="group inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary group-hover:underline">
                        {{
                        creatorInquiry()!.creator!.firstName + ' ' +
                        creatorInquiry()!.creator!.lastName.charAt(0) + '.'
                        }}
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">{{ creatorInquiry()!.socialMonitoringBrief?.briefTitle }}</p>
                }
            </div>
        </div>

    </div>
    <!-- Header - END -->

    <!-- Main Content -->
    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
        <div class="grid grid-cols-1 h-full">
            <article class="col-span-1 lg:col-span-8 2xl:col-span-9 flex flex-col gap-y-2 flex-1 overflow-hidden">
                <!-- Monitoring status -->
                <!-- <div class="shrink-0 w-full flex flex-row gap-x-4">
                    <div
                        class="flex-1 rounded-lg bg-green-50 dark:bg-green-900/30 p-4 ring-1 ring-inset ring-green-600 ring-green-20">
                    </div>
                </div> -->
                <!-- Monitoring status - END -->

                <!-- Published Content -->
                <div
                    class="flex-1 w-full divide-y divide-gray-200 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow flex flex-col min-h-0">
                    <div class="border-b border-gray-200 px-3 py-3 dark:border-white/10 shrink-0">
                        <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                            <div class="">
                                <h3 class="text-sm font-semibold text-primary">Published Content</h3>
                                <p class="hidden sm:block mt-0.5 text-xs text-secondary">Content published by this
                                    creator for this brief.</p>
                            </div>
                            <div class="shrink-0 flex flex-row items-center gap-x-2">
                            </div>
                        </div>
                    </div>

                    @if (creatorInquiry() && creatorInquiry()!.publishedContent &&
                    creatorInquiry()!.publishedContent!.length > 0) {
                    <div class="p-2 overflow-y-auto flex-1 min-h-0 scrollbar-transparent">
                        <ul role="list" class="grid grid-cols-1 gap-3" [class]="'sm:grid-cols-4 2xl:grid-cols-4'">
                            @for (video of creatorInquiry()!.publishedContent; track $index) {
                            <li class="relative col-span-1 flex flex-col text-center card-container-pale self-start">
                                <div class="absolute z-10 top-2 right-2 mt-2 mr-2">
                                    <div class="social-plt-badge text-secondary">
                                        @if (video.socialPlatform == 'TikTok') {
                                        <img class="size-5 mx-auto"
                                            src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                                            alt="TikTok">
                                        } @else if (video.socialPlatform == 'Instagram') {
                                        <img class="size-5 mx-auto"
                                            src="../../../../../assets/social-icon/instagram-logo.png" alt="Instagram">
                                        } @else {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M12 6v12" />
                                            <path d="M17.196 9 6.804 15" />
                                            <path d="m6.804 9 10.392 6" />
                                        </svg>
                                        }
                                    </div>
                                </div>
                                <div class="overflow-hidden">
                                    @if (video.video) {
                                    <div class="aspect-9/16 overflow-hidden rounded-lg w-full">
                                        <mb-atom-video-preview class="w-full h-full"
                                            [video]="video.video"></mb-atom-video-preview>
                                    </div>
                                    } @else if (video.images && video.images.length > 0) {
                                    <div
                                        class="aspect-9/16 overflow-hidden rounded-lg hover:cursor-pointer w-full flex flex-col items-center justify-center">
                                        <mb-atom-carousel-preview class="w-full h-full"
                                            [images]="video.images"></mb-atom-carousel-preview>
                                    </div>
                                    } @else {
                                    <div
                                        class="aspect-9/16 overflow-hidden rounded-lg hover:cursor-pointer w-full flex flex-col items-center justify-center">
                                        <div class="text-center">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                aria-hidden="true"
                                                class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                                                <path
                                                    d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                                    stroke-width="2" vector-effect="non-scaling-stroke"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No assets</h3>
                                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ video.contentId }}</p>
                                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Get started by
                                                adding assets to this content.</p>
                                            <div class="mt-6">
                                                <cmol-creator-monitor-add-asset
                                                    [publishedContentId]="video.id"
                                                    [inquiryId]="creatorInquiry()!.id"
                                                    (assetsAttached)="onAssetsAttached()">
                                                </cmol-creator-monitor-add-asset>
                                            </div>
                                        </div>

                                    </div>
                                    }
                                </div>

                                <div
                                    class="flex w-full items-center space-x-2 justify-between mt-2 border-b border-gray-200 dark:border-white/10 pb-2">
                                    @if (video.creator && video.creator.photoURL) {
                                    <img [src]="imageService.getImageSource(video.creator.photoURL, 'gallery')" alt=""
                                        class="size-10 shrink-0 rounded-full bg-gray-300 outline -outline-offset-1 outline-black/5" />
                                    } @else {
                                    <img [src]="imageService.getImageSource(placeholderImage(), 'gallery')" alt=""
                                        class="size-10 shrink-0 rounded-full bg-gray-300 outline -outline-offset-1 outline-black/5" />
                                    }

                                    <div class="flex-1 truncate">
                                        <div class="flex items-start space-x-3">
                                            <h3 class="truncate text-sm font-medium text-primary">{{ getHandle(video) }}
                                            </h3>
                                        </div>
                                        @if (creatorInquiry()!.creator) {
                                        <p class="truncate text-xs text-secondary text-start">{{
                                            creatorInquiry()!.creator.firstName }} {{
                                            creatorInquiry()!.creator.lastName.charAt(0) }}.</p>
                                        <p class="truncate text-xs text-secondary text-start">{{
                                            formatService.getTimeSinceUpdated(video.timestamp) }}</p>
                                        } @else {
                                        <p class="truncate text-xs text-secondary text-start">First Name</p>
                                        <p class="truncate text-xs text-secondary text-start">{{
                                            formatService.getTimeSinceUpdated(video.timestamp) }}</p>
                                        }
                                    </div>
                                    <div
                                        class="size-8 shrink-0 rounded-full bg-gray-50 dark:bg-gray-800 outline -outline-offset-1 outline-black/5 dark:outline dark:-outline-offset-1 dark:outline-white/10 flex items-center justify-center">
                                        @if (video.video) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5 text-secondary">
                                            <path
                                                d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
                                            <rect x="2" y="6" width="14" height="12" rx="2" />
                                        </svg>
                                        } @else {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-5 text-secondary">
                                            <rect width="18" height="14" x="3" y="3" rx="2" />
                                            <path d="M4 21h1" />
                                            <path d="M9 21h1" />
                                            <path d="M14 21h1" />
                                            <path d="M19 21h1" />
                                        </svg>
                                        }
                                    </div>
                                </div>

                                <div
                                    class="flex w-full grid grid-cols-5 gap-x-1 border-b border-gray-200 dark:border-white/10">
                                    <div class="p-2 flex flex-col items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-4 text-accent">
                                            <path
                                                d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                        <p class="mt-1 text-md font-semibold tabular-nums text-foreground">
                                            {{ formatService.convertIntToString(getViews(video)) }}
                                        </p>
                                    </div>

                                    <div class="p-2 flex flex-col items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-4 text-pink-600 dark:text-pink-400">
                                            <path
                                                d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
                                        </svg>
                                        <p class="mt-1 text-md font-semibold tabular-nums text-foreground">
                                            {{ formatService.convertIntToString(getLikes(video)) }}
                                        </p>
                                    </div>

                                    <div class="p-2 flex flex-col items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-4 text-blue-600 dark:text-blue-400">
                                            <path
                                                d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                                        </svg>
                                        <p class="mt-1 text-md font-semibold tabular-nums text-foreground">
                                            {{ formatService.convertIntToString(getComments(video))
                                            }}
                                        </p>
                                    </div>

                                    <div class="p-2 flex flex-col items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-4 text-emerald-600 dark:text-emerald-400">
                                            <circle cx="18" cy="5" r="3" />
                                            <circle cx="6" cy="12" r="3" />
                                            <circle cx="18" cy="19" r="3" />
                                            <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                                            <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                                        </svg>
                                        <p class="mt-1 text-md font-semibold tabular-nums text-foreground">
                                            {{ formatService.convertIntToString(getShares(video)) }}
                                        </p>
                                    </div>

                                    <div class="p-2 flex flex-col items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="size-4 text-cyan-600 dark:text-cyan-400">
                                            <line x1="19" x2="5" y1="5" y2="19" />
                                            <circle cx="6.5" cy="6.5" r="2.5" />
                                            <circle cx="17.5" cy="17.5" r="2.5" />
                                        </svg>
                                        <p class="mt-1 text-md font-semibold tabular-nums text-foreground">
                                            {{ getEngagementRate(video) }}
                                        </p>
                                    </div>
                                </div>

                                <div class="w-full flex flex-col items-start justify-start px-2 py-2">
                                    <h3 class="text-sm font-semibold text-primary">Match</h3>
                                    <p class="mt-1 text-xs text-secondary text-left">{{ video.match.concept }}</p>
                                </div>

                            </li>
                            }
                        </ul>
                    </div>
                    } @else if (creatorInquiry() && creatorInquiry()!.publishedContent &&
                    creatorInquiry()!.publishedContent!.length == 0) {
                    <div class="w-full h-full flex flex-col items-center justify-center">
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 0 1-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 0 0-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409" />
                            </svg>
                            <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">No content found</h3>
                            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Creator has not published any
                                content for this brief.</p>
                            <div class="mt-6">
                                <button (click)="reconcileContent()" type="button" [disabled]="reconciling()"
                                    class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500">
                                    @if (reconciling()) {
                                    <svg class="mr-1.5 -ml-0.5 size-5 animate-spin" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 24 24" aria-hidden="true">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                    </svg>
                                    Reconciling…
                                    } @else {
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="mr-1.5 -ml-0.5 size-5">
                                        <path
                                            d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                                    </svg>
                                    Reconcile Content
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                    } @else {
                    <div class="flex h-full w-full items-center justify-center">
                        <atom-loading-inline title="Loading..." message="Loading submissions..."></atom-loading-inline>
                    </div>
                    }






                </div>
                <!-- Published Content - END -->
            </article>
        </div>
    </div>
    <!-- Main Content - END -->
</div>